import { DoneButton } from 'components/blue-button'
import DismissButton from 'components/dismiss-button'
import { useState } from 'react'
import { useRenameClassMutation } from 'util/rtk-api'
import styles from 'css/components/classroom/add-new-student-overlay.module.css'

interface RenameClassOverlayProps {
    classId: string
    currentName: string
    setShowRenameClassOverlay: (show: boolean) => void
}

export const RenameClassOverlay = ({ classId, currentName, setShowRenameClassOverlay }: RenameClassOverlayProps) => {
    const [newName, setNewName] = useState(currentName)
    const [renameClass, { isLoading }] = useRenameClassMutation()

    const handleRename = async () => {
        if (newName.trim() && newName !== currentName) {
            try {
                await renameClass({ classId, name: newName.trim() })
                setShowRenameClassOverlay(false)
            } catch (error) {
                console.error('Error renaming class:', error)
            }
        }
    }

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            handleRename()
        } else if (e.key === 'Escape') {
            setShowRenameClassOverlay(false)
        }
    }

    return (
        <div className="overlay">
            <div className="overlay-content-container">
                <div className="overlay-content-header">
                    <h3>Rename Class</h3>
                    <DismissButton onClick={() => setShowRenameClassOverlay(false)} />
                </div>
                <div className={`overlay-content-body`}>
                    <div className={styles.flexColumn}>
                        <label>Class Name:</label>
                        <input
                            type="text"
                            value={newName}
                            onChange={(e) => setNewName(e.target.value)}
                            onKeyDown={handleKeyDown}
                            placeholder="Enter new class name"
                            autoFocus
                            className={styles.input}
                        />
                    </div>
                    <div className="alignRight">
                        <DoneButton onClick={handleRename} disabled={isLoading || !newName.trim()} />
                    </div>
                </div>
            </div>
        </div>
    )
}
